import type { FieldErrors } from "react-hook-form";

export function collectErrorMessages(errors: FieldErrors): string[] {
    const messages: string[] = [];

    function recurse(errorObj: FieldErrors) {
        Object.entries(errorObj).forEach(([_key, error]) => {
            if (error && typeof error === "object") {
                if ("message" in error && typeof error.message === "string") {
                    messages.push(error.message);
                }
                // Recursively check nested errors
                recurse(error as FieldErrors);
            }
        });
    }

    recurse(errors);
    return messages;
}
